<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <card class="shadow">
          <div class="row">
            <div class="col">
              <div v-if="loading" class="text-warning">Loading, please wait...</div>
              <div>
                <div v-if="companyObject.logoPath" class="pull-left">
                  <img class="mr-2" height="100" :src="companyObject.logoPath" alt="logo">
                </div>
                <div>
                  <div v-if="actions.canCaseExportExcel" v-show="renderCriteria" class="pull-right"><a href="javascript:void(0);" @click="exportAsExcel"><span class="icomoon-cloud-download"></span>&nbsp;export&nbsp;as&nbsp;excel</a></div>
                  <div class="form-inline">
                    <h1 class="m-0 mr-3">{{ companyObject.tradeTitle }}</h1>
                    <select v-if="companyObject.caseObjects.length" v-model="caseObject.id" class="form-control" @change="changeCase">
                      <option v-for="(item, index) in companyObject.caseObjects" :key="index" :value="item.id">{{ item.year }}</option>
                    </select>
                    <select v-model="selectedFramework" class="form-control ml-2" @change="changeCase">
                      <option v-for="(item, index) in frameworks" :key="index" :value="item">{{ item }}</option>
                    </select>
                  </div>
                  <div class="small mt-1">{{ companyObject.title }}</div>
                  <div v-if="companyObject.vatNumber" class="small mt-1">TAX ID NUMBER:&nbsp;{{ companyObject.vatNumber }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div v-if="companyObject.country || companyObject.region" class="info-box">
                <div style="font-size:35px;">{{ companyObject.country }}</div>
                <div>{{ companyObject.region }}</div>
              </div>
              <div v-if="caseObject.turnover || caseObject.size" class="info-box">
                <div v-if="caseObject.turnover" style="font-size:35px;">Turnover&nbsp;(&euro;): {{ formatTurnover(caseObject.turnover) }}</div>
                <div v-if="caseObject.size" style="font-size:35px;">Size: {{ caseObject.size }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div v-if="companyObject.industry.title" class="info-box">
                <div style="font-size: 35px;">{{ companyObject.industry.title }} ({{ companyObject.industry.naceCode }})</div>
                <div v-if="industryParents.length>0">
                  <div>Broader Industries:</div>
                  <ul>
                    <li v-for="(item, index) in industryParents" :key="index">{{ item.title }} ({{ item.naceCode }})</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </card>
        <div v-for="(pillr, index) in pillars" :key="index" :class="{card:true, shadow:true}">
          <div class="card-body">
            <ul class="questions_tree mt-4">
              <tree-item
                v-if="renderCriteria"
                class="tree-item"
                :icon="pillarIcon(pillr)"
                :item="topicsTree[pillr]"
                :is-open-init="true"
              ></tree-item>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
import TreeItem from "../components/TreeItem";
export default {
  name: "Company",
  components: {
    TreeItem,
  },
  data () {
    return {
      loading: true,
      renderCriteria: false,
      errorMessage: '',
      caseObject: {
        id: null,
        year: null,
        summaryOverall: null,
        turnover: null,
        size: null
      },
      companyObject: {
        id: parseInt(this.$route.params.companyId),
        title: null,
        tradeTitle: null,
        vatNumber: null,
        industry: {
          title: null,
          naceCode: null
        },
        country: null,
        region: null,
        logoPath: null,
        caseObjects: []
      },
      industryParents: [],
      topicsTree: {
        environmental: {
          title: 'Environmental Criteria',
          id: null,
          childrenDtos: []
        },
        social: {
          title: 'Social Criteria',
          id: null,
          childrenDtos: []
        },
        governance: {
          title: 'Governance Criteria',
          id: null,
          childrenDtos: []
        },
        financial: {
          title: 'Financial Criteria',
          id: null,
          childrenDtos: []
        },
        general: {
          title: 'General Criteria',
          id: null,
          childrenDtos: []
        },
      },
      topicsFlat: {},
      actions: {
        canCaseExportExcel: this.$root.canUserDo(['case_export_excel'])
      },
      frameworks: ['nza'],
      selectedFramework: 'nza',
      pillars: ['environmental']
    }
  },
  mounted () {
    this.fetchFrameworks();
  },
  computed: {
    
  },
  methods: {
    pillarIcon(pillar) {
      switch(pillar) {
        case 'environmental':
          return 'icomoon-leaf';
        case 'social':
          return 'icomoon-man-woman';
          case 'governance':
          return 'icomoon-briefcase';
        case 'financial':
          return 'icomoon-coin-euro';
        case 'general':
          return 'icomoon-info';
        default:
          return 'icomoon-earth';
      }
    },
    fetchCaseData() {
      let self = this;
      Api.send('GET', '/prism/cases/' + self.caseObject.id + '?frameworks[]=' + self.selectedFramework, {})
      .then((response) => {
        self.errorMessage = '';

        self.caseObject.year = response.case.year;
        self.caseObject.summaryOverall = response.case.summaryOverall;

        self.companyObject.title = response.company.title;
        self.companyObject.tradeTitle = response.company.tradeTitle;
        self.companyObject.vatNumber = response.company.vatNumber;
        self.companyObject.industry = response.company.industryDto;
        self.companyObject.country = response.company.addressDto.regionalUnitDto.regionDto.countryDto.title;
        self.companyObject.region = response.company.addressDto.regionalUnitDto.regionDto.title;
        self.companyObject.logoPath = response.company.logoPath;

        self.industryParents = response.industryParents;

        for (let topicId in self.topicsFlat) {
          self.topicsFlat[topicId]['questionDtos'] = [];
        }

        let turnoverFound = false;
        let sizeFound = false;
        for (let i in response.questions) {
          let item = response.questions[i];
          if (item.criterionId === 139 && item.evaluationId && item.analystAnswerNumeric) {
            self.caseObject.turnover = item.analystAnswerNumeric;
            turnoverFound = true;
          }
          if (item.criterionId === 203 && item.evaluationId && item.analystAnswerText) {
            self.caseObject.size = item.analystAnswerText;
            sizeFound = true;
          }
          self.topicsFlat[item['topicId']]['questionDtos'].push(item);
        }

        if (!turnoverFound) {
          self.caseObject.turnover = null;
        }
        if (!sizeFound) {
          self.caseObject.size = null;
        }

        self.renderCriteria = true;
        self.loading = false;
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    changeCase() {
      this.errorMessage = '';
      this.loading = true;
      this.renderCriteria = false;
      this.$nextTick(() => {
        this.fetchCaseData();
      })
    },
    fetchTopicsTree() {
      let self = this;
      Api.send('GET', '/prism/topics/all/tree', {})
      .then((response) => {
        self.errorMessage = '';
        self.topicsTree.environmental.childrenDtos = response.environmental;
        self.topicsTree.social.childrenDtos = response.social;
        self.topicsTree.governance.childrenDtos = response.governance;
        self.topicsTree.financial.childrenDtos = response.financial;
        self.topicsTree.general.childrenDtos = response.general;
        self.registerTopicsFlat();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
        self.topicsTree.environmental.childrenDtos = [];
        self.topicsTree.social.childrenDtos = [];
        self.topicsTree.governance.childrenDtos = [];
        self.topicsTree.financial.childrenDtos = [];
        self.topicsTree.general.childrenDtos = [];
      });
    },
    fetchFrameworks() {
      let self = this;
      Api.send('GET', '/frameworks', {})
      .then((response) => {
        self.frameworks = response;
        self.selectedFramework = response[0];
        self.fetchPillars();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    fetchPillars() {
      let self = this;
      Api.send('GET', '/pillars', {})
      .then((response) => {
        self.pillars = response;
        self.fetchCompanyCases();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    fetchCompanyCases() {
      let self = this;
      Api.send('GET', '/prism/companies/' + self.companyObject.id + '/cases', {})
      .then((response) => {
        self.errorMessage = '';
        self.companyObject.caseObjects = response;
        self.caseObject.id = self.companyObject.caseObjects[0]['id'];
        this.fetchTopicsTree();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    registerTopicsFlat() {
      this.topicsFlat = {};
      for (let i in this.topicsTree.environmental.childrenDtos) {
        this.registerChildren(this.topicsTree.environmental.childrenDtos[i]);
      }
      for (let i in this.topicsTree.social.childrenDtos) {
        this.registerChildren(this.topicsTree.social.childrenDtos[i]);
      }
      for (let i in this.topicsTree.governance.childrenDtos) {
        this.registerChildren(this.topicsTree.governance.childrenDtos[i]);
      }
      for (let i in this.topicsTree.financial.childrenDtos) {
        this.registerChildren(this.topicsTree.financial.childrenDtos[i]);
      }
      for (let i in this.topicsTree.general.childrenDtos) {
        this.registerChildren(this.topicsTree.general.childrenDtos[i]);
      }
      this.fetchCaseData();
    },
    registerChildren(item) {
      item.criteriaDtos = null;
      this.topicsFlat[item.id] = item;
      this.topicsFlat[item.id]['questionDtos'] = [];
      if (item.childrenDtos.length > 0) {
        for (let i in item.childrenDtos) {
          this.registerChildren(item.childrenDtos[i])
        }
      }
    },
    exportAsExcel() {
      let loggedUser = this.$root.getLoggedUser();
      location.replace(Api.getBaseUrl() + '/prism/cases/' + this.caseObject.id + '/export_excel?bearer_token=' + loggedUser.token + '&frameworks[]=' + this.selectedFramework);
    },
    formatTurnover(turnover) {
      if (turnover > 1000000000000) {
        return (turnover/1000000000000).toFixed(2) + 'T'
      }

      if (turnover > 1000000000) {
        return (turnover/1000000000).toFixed(2) + 'B'
      }

      if (turnover > 1000000) {
        return (turnover/1000000).toFixed(2) + 'M'
      }

      if (turnover > 1000) {
        return (turnover/1000).toFixed(2) + 'K'
      }

      return turnover.toFixed(2);
    }
  }
};
</script>
<style scoped>
.questions_tree {
  padding-left: 0;
  line-height: 2em;
  list-style-type: none;
  font-size: 1.2em;
}
.card.environmental {
  border: 2px solid #2dce89;
  background-color: rgb(45 206 137 / 13%);
}
.card.social {
  border: 2px solid #ffd600;
  background-color: rgb(255 214 0 / 13%);
}
.card.governance {
  border: 2px solid #5e72e4;
  background-color: rgb(94 114 228 / 13%);
}
.card.financial {
  border: 2px solid #e45e5e;
  background-color: rgb(228 94 94 / 13%);
}
.card.general {
  border: 2px solid #a1a1a1;
  background-color: rgb(231, 231, 236);
}
.card .info-box {
  background-color: rgb(235, 235, 235);
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
}
.info-box ul>li {
  color: inherit;
}
</style>
